<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" @onChange="onChange" />
  </div>
</template>

<script>
  import {
    Editor,
    Toolbar
  } from '@wangeditor/editor-for-vue'

  export default {
    components: {
      Editor,
      Toolbar
    },
    model: {
      prop: "desc",
      event: "change"
    },
    props: {
      desc: String,
    },



    data() {
      return {
        content: "",
        Editor: "",

        editor: null,
        html: '',
        toolbarConfig: {},
        editorConfig: {
          placeholder: '請輸入内容...',
          MENU_CONF: {
            uploadImage: {
              server: this.$api.BaseUrl + this.$api.uploadImage,
              fieldName: 'file',
              maxFileSize: 10 * 1024 * 1024,
              maxNumberOfFiles: 10,
              allowedFileTypes: [],
              metaWithUrl: false,
              timeout: 10 * 1000, //10 秒
              // 上传前
              onBeforeUpload(files) {
                return files;
              },
              // 自定义插入圖片
              customInsert(res, insertFn) {

                if (res.code==1) {
                  console.log(res.data.fullPath)
                  insertFn(res.data.fullPath,'1',res.data.fullPath)
                }
                // insertFn(res.data.link, res.data.name, res.data.link);
              },

              // 单个文件上传成功之后
              onSuccess(file, res) {
                console.log(res)
                // console.log(`${file.name} 上传成功`, res);
              },

              // 单个文件上传失败
              onFailed(file, res) {
                // console.log(`${file.name} 上传失败`, res);
              },

              // 上传进度的回调函数
              onProgress(progress) {
                // console.log('progress', progress);
                // progress 是 0-100 的数字
              },

              // 上传错误，或者触发 timeout 超时
              onError(file, err, res) {
                // console.log(`${file.name} 上传出错`, err, res);
              }
            },
            }
          },
          mode: 'default', // or 'simple'
        }
      },
      watch: {
          desc: {
            immediate: true,
            handler(value) {
              if (value) {
                this.html = value
              }
            }
          },
        },
        mounted() {
        },
        methods: {
          onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            this.editorConfig.MENU_CONF['uploadImage'] = {
              service: this.$api.BaseUrl + this.$api.uploadImage,
              onSuccess(file, res) {
                console.log('success', file, res)
              },
            }

          },
          onChange(editor) {
            this.html = editor.getHtml()
            this.$emit("change", this.html);
            // console.log('onChange', editor.getHtml())
          },
        },
        beforeDestroy() {
          const editor = this.editor
          if (editor == null) return
          editor.destroy() // 组件销毁时，及时销毁编辑器
        }
    }
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/wangEditor.vue